/**
 * 隐藏手机号码中间四位
 * */
export const hidePhone = (phone, len = 4) => {
  if (!phone) return phone;
  return phone.replace(
    new RegExp("^(\\d{3}).+(\\d{" + (8 - len) + "})$"),
    `$1${"*".repeat(len)}$2`
  );
};

/**
 * 隐藏姓名第一位以外的,保留三位
 * */
export const hideName = name => {
  if (!name) return name;
  return name.replace(/^(.).+/, "$1**");
};
/**
 * 隐藏身份证
 * */
export const hideIdCard = idCard => {
  if (!idCard) return idCard;
  return idCard.replace(idCard.substr(6, 8), "****");
};
// 数组倒叙
export const reverseArr = arr => {
  let newArr = [];
  for (let i = arr.length; i--; i > 0) {
    newArr.push(arr[i]);
  }
  return newArr;
};

//考试形式
export const examFormType = examForm => {
  if (examForm == "1") {
    return "开卷";
  } else if (examForm == "2") {
    return "闭卷";
  } else if (examForm == "3") {
    return "半开卷";
  } else if (examForm == "4") {
    return "其他";
  }
};
//考试方式
export const examMannerType = examManner => {
  if (examManner == "1") {
    return "远程网考";
  } else if (examManner == "2") {
    return "集中网考";
  }
};
//考试状态
export const examStatusType = examStatus => {
  if (examStatus == "1") {
    return "可预约";
  } else if (examStatus == "2") {
    return "已预约";
  } else if (examStatus == "3") {
    return "待考试";
  } else if (examStatus == "4") {
    return "已考试";
  } else if (examStatus == "5") {
    return "考试中";
  }
};

//是否补考
export const ifMakeUpMakeType = ifMakeUpMake => {
  if (ifMakeUpMake == "1") {
    return "是";
  } else if (ifMakeUpMake == "0") {
    return "否";
  }
};

//是否通过
export const ifpassedType = ifpassed => {
  if (ifpassed == "1") {
    return "通过";
  } else if (ifpassed == "2") {
    return "不通过";
  }
};

//高起专or专升本
export const pfsnLevelType = pfsnLevel => {
  if (pfsnLevel == "1") {
    return "1>专科升本科类";
  } else if (pfsnLevel == "5") {
    return "5>高中起点高职高专";
  } else {
    return "";
  }
};




// WEBPACK FOOTER //
// ./src/filters/index.js